import React from "react";
import { ViewItem } from "../../../Components/Views/ViewItem";
import { CopyModal } from "../../../Controllers/ModalControllers/CopyModal";
import './copy-modal-styles.css'

class CopyModalView extends ViewItem {

  get controller():CopyModal {
    return this.props.controller;
  }

  render() {
    const { visible, hide } = this.controller;
    if(!visible){
        return null;
    }
    return (<div className="notification-overlay">
            <div className="notification">
              <svg className="notification-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 6L9 17l-5-5" />
              </svg>
              <div className="notification-content">
                <div className="notification-title">URL copied to clipboard!</div>
                <div className="notification-url">{window.location.href}</div>
              </div>
            </div>
          </div>);
  }
}

export { CopyModalView };